<ng-template #list let-obj>
    <ng-container *ngTemplateOutlet="obj.ordered ? ordered : unordered; context: { $implicit: obj }"></ng-container>
</ng-template>

<ng-template #unordered let-obj>
    <ul [attr.role]="obj?.listItems ? 'list' : 'none'">
        <ng-container *ngTemplateOutlet="listItems; context: { $implicit: obj?.listItems }"></ng-container>
    </ul>
</ng-template>

<ng-template #ordered let-obj>
    <ol [attr.role]="obj?.listItems ? 'list' : 'none'">
        <ng-container *ngTemplateOutlet="listItems; context: { $implicit: obj?.listItems }"></ng-container>
    </ol>
</ng-template>

<ng-template #listItems let-listItems>
    <li *ngFor="let listItem of listItems" role="listitem" [class.list-style-none]="listItem.listStyleNone+'' === 'true'">
        <span [innerHTML]="(listItem?.substring ? listItem : listItem?.content) | safeHtml"></span>
        <ng-container *ngTemplateOutlet="list; context: { $implicit: listItem }" [ngIf]="listItem?.listItems"></ng-container>
        <ng-container *ngTemplateOutlet="blockquote; context: { $implicit: listItem }"></ng-container>
        <app-generic-template *ngIf="listItem?.children && listItem?.type !== 'blockquote'" [content]="listItem"></app-generic-template>
    </li>
</ng-template>

<ng-template #descriptionList let-content>
    <dl>
        <ng-container *ngFor="let listItem of content?.listItems">
            <dt [innerHTML]="listItem?.term | safeHtml"></dt>
            <dd [innerHTML]="listItem?.description | safeHtml"></dd>
        </ng-container>
    </dl>
</ng-template>

<ng-template #blockquote let-obj>
    <blockquote *ngIf="obj?.type === 'blockquote'">
        <app-generic-template *ngIf="obj?.children" [content]="obj"></app-generic-template>
    </blockquote>
</ng-template>

<ng-template #paragraph let-obj>
    <p [innerHTML]="(obj?.content || obj) | safeHtml"></p>
</ng-template>

<ng-template #hr let-obj>
	<hr aria-hidden="true" role="presentation" />
</ng-template>

<ng-template #formGroup let-obj>
	<form [formGroup]="formGroups[obj.formGroupName]">
		<cds-column *ngFor="let input of obj?.inputs"
			[xs]="input?.colSpan?.xs || input?.colSpan?.default || 12"
			[sm]="input?.colSpan?.sm || input?.colSpan?.default || 12"
			[md]="input?.colSpan?.md || input?.colSpan?.default || 12"
			[lg]="input?.colSpan?.lg || input?.colSpan?.default || 12"
		>
			<ng-container *ngTemplateOutlet="this[input.type] || this['paragraph']; context: { input: input, formGroup: formGroups[obj.formGroupName] }"></ng-container>
		</cds-column>
	</form>
</ng-template>

<ng-template #input let-input="input" let-formGroup="formGroup">
	<cds-form-field
		[class.show-label]="input.alwaysShowLabel"
		(focused)="input.focuses == $event"
		[formGroup]="formGroup"
		#field
	>
		<label cdsLabel
			*ngIf="input.label"
			[attr.for]="input.id"
			[attr.aria-hidden]="true"
			[innerHTML]="input.label | safeHtml"
		></label>

		<input cdsInput
			[id]="input.id"
			[name]="input.id"
			[formControlName]="input.id"
			[placeholder]="input.placeholder || input.label"
			[attr.type]="input.subType || 'text'"
			[attr.maxlength]="input.maxLength"
			(input)="limitInputLength($event)"
			ngDefaultControl
		/>

		<cds-error *ngFor="let validator of input.validators" [on]="validator.type">
			<span [innerHTML]="validator.message | safeHtml"></span>
		</cds-error>
	</cds-form-field>
</ng-template>

<ng-template #radio let-input="input" let-formGroup="formGroup">
	<cds-form-field
		[formGroup]="formGroup"
		#radioGroup
	>
		<legend *ngIf="input.label"
			[attr.for]="input.id"
			[innerHTML]="input.label | safeHtml"
		></legend>

		<cds-radio-group
			[formControlName]="input.id"
			[error]="radioGroup.inErrorState"
		>
			<cds-radio
				*ngFor="let radioObj of input.options"
				[name]="input.id"
				[value]="radioObj.value || radioObj"
				(checkedChange)="radioGroup.validate()"
			>
				<span [innerHTML]="(radioObj.label || radioObj) | safeHtml"></span>
			</cds-radio>
		</cds-radio-group>

		<cds-error *ngFor="let validator of input.validators" [on]="validator.type">
			<span [innerHTML]="validator.message | safeHtml"></span>
		</cds-error>
	</cds-form-field>
</ng-template>

<ng-template #checkbox let-input="input" let-formGroup="formGroup">
	<cds-form-field
		[formGroup]="formGroup"
		#checkboxGroup
	>
		<legend *ngIf="input.label"
			[attr.for]="input.id"
			[innerHTML]="input.label | safeHtml"
		></legend>

		<cds-checkbox-group
			[formControlName]="input.id"
			legendText=""
			[error]="checkboxGroup.inErrorState"
		>
			<cds-checkbox
				*ngFor="let checkboxObj of input.options"
				[name]="input.id"
				[label]="checkboxObj.label || checkboxObj"
				[value]="checkboxObj.value || false"
				(checkedChange)="checkboxGroup.validate()"
			></cds-checkbox>
		</cds-checkbox-group>

		<cds-error *ngFor="let validator of input.validators" [on]="validator.type">
			<span [innerHTML]="validator.message | safeHtml"></span>
		</cds-error>
	</cds-form-field>
</ng-template>

<ng-template #dropdown let-input="input" let-formGroup="formGroup" let-options="options">
	<cds-form-field
		(focused)="input.focuses == $event"
		(hasValueChange)="input.hasValue == $event || input.hasValue"
		[class.show-label]="input.alwaysShowLabel || input.hasValue"
		[formGroup]="formGroup"
		#dropdownField
	>
		<label cdsLabel
			*ngIf="input.label || input.placeholder"
			[attr.for]="input.id"
			[attr.aria-hidden]="true"
			[innerHTML]="(input.label || input.placeholder) | safeHtml"
		></label>

		<cds-dropdown
		  [formControlName]="input.id"
		  [formRef]="dropdownField"
		  [placeholder]="input.placeholder || input.label"
		  [required]="true"
		  #dropdown
		>
			<cds-option
				*ngFor="let option of (options || input.options); let i = index"
				[label]="option.label || option"
				[value]="option.value || option"
				(ddValue)="obj.hasValue = true"
			>
			</cds-option>
		</cds-dropdown>

		<cds-error *ngFor="let validator of input.validators" [on]="validator.type">
			<span [innerHTML]="validator.message | safeHtml"></span>
		</cds-error>
	  </cds-form-field>
</ng-template>

<ng-template #statesDropdown let-input="input" let-formGroup="formGroup">
	<ng-container *ngTemplateOutlet="dropdown; context: { input: input, formGroup: formGroup , options: STATES }; "></ng-container>
</ng-template>

<ng-template #heading let-obj>
	<citi-text-header
  		[level]="obj.level"
  		[styleLevel]="obj.styleLevel"
		[class]="'header-' + (obj?.styleLevel || obj?.level)"
		[class.inline-heading]="obj?.isInline"
		[class.no-padding-bottom]="obj?.noPaddingBottom"
	><span [innerHTML]="obj.content | safeHtml"></span></citi-text-header>
</ng-template>


<ng-container *ngFor="let mainElem of (content?.children || content?.listItems)">
    <ng-container *ngTemplateOutlet="this[mainElem.type] || this['paragraph']; context: { $implicit: mainElem }"></ng-container>
</ng-container>
